module.exports = __webpack_public_path__ + "static/media/amco-saft.cf40c4b2.svg";